<template>
  <div id="lot-map" v-if="ok">

    <vx-card ref="filterCard" title="Filtros" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">TIPO</label>
          <v-select :options="typeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="typeFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">SEGMENTO</label>
          <v-select :options="trackingOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="trackingFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">LOCAL</label>
          <v-select :options="locationNameOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="locationNameFilter" class="mb-4 md:mb-0" />
        </div>
      </div>
    </vx-card>

    <div class="vx-card no-scroll-content">
      <gmap-map v-if="markers[0]" ref="gmap" :center="markers[0].position" :zoom="15" style="width: 100%; height: 500px">
          <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :icon="markerIcon(m.alertState)" :clickable="true">
            <gmap-info-window :options="infoOptions" :position="m.position">
              {{ m.name }}
            </gmap-info-window>
          </gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data () {
    return {
      ok: false,
      customers: [],
      connections: [],
      filteredConnections: [],
      filteredCustomers: [],
      infoOptions: { pixelOffset: { width: 0, height: -15 } },
      // Filter Options
      typeFilter: { label: 'Todos', value: 'all' },
      typeOptions: [
        { label: 'Todos', value: 'all' },
        { label: 'Fornecedor', value: 'Fornecedor' },
        { label: 'Cliente', value: 'Cliente' },
        { label: 'Operador logístico', value: 'Operador logístico' }
      ],
      trackingFilter: { label: 'Todos', value: 'all' },
      trackingOptions: [
        { label: 'Todos', value: 'all' },
        { label: 'Alimentícia', value: 'Alimentícia' },
        { label: 'CD (Centro de Distribuição)', value: 'CD (Centro de Distribuição)' },
        { label: 'Cosméticos', value: 'Cosméticos' },
        { label: 'Eletrônico', value: 'Eletrônico' },
        { label: 'Farmacêutico', value: 'Farmacêutico' },
        { label: 'Florestal', value: 'Florestal' },
        { label: 'Higiene', value: 'Higiene' },
        { label: 'Logística', value: 'Logística' },
        { label: 'Mat. de construção', value: 'Mat. de construção' },
        { label: 'Moda', value: 'Moda' },
        { label: 'Plástico', value: 'Plástico' },
        { label: 'Têxtil', value: 'Têxtil' },
        { label: 'Varejo', value: 'Varejo' }
      ],
      locationNameFilter: { label: 'Todos', value: 'all' }
    }
  },
  computed: {
    markers () {
      const connections = this.filteredConnections.map(e => { return { position: e.location, alertState: true, name: e.name } })
      const customers = this.filteredCustomers.map(e => { return { position: e.location, alertState: false, name: e.name } })
      return connections.concat(customers)
    },
    locationNameOptions () {
      const result = [{ label: 'Todos', value: 'all' }]
      const optionsCon = this.connections.map(e => { return { label: e.locationName, value: e.locationName } })
      const optionsCus = this.customers.map(e => { return { label: e.locationName, value: e.locationName } })
      const options = optionsCon.concat(optionsCus)
      for (let i = 0; i < options.length; i++) if (!result.map(e => e.label).includes(options[i].label)) result.push(options[i])
      return result
    }
  },
  watch: {
    typeFilter () { this.filterConnections() },
    trackingFilter () { this.filterConnections() },
    locationNameFilter () { this.filterConnections() }
  },
  methods: {
    fixMap () {
      if (this.markers && this.markers.length > 0) {
        setTimeout(() => {
          this.$refs.gmap.$mapPromise.then((map) => {
            // eslint-disable-next-line
            const bounds = new google.maps.LatLngBounds()
            for (const m of this.markers) {
              bounds.extend(m.position)
            }
            map.fitBounds(bounds)
          })
        }, 4000)
      }
    },
    filterConnections () {
      const type = this.typeFilter.value
      const tracking = this.trackingFilter.value
      const locationName = this.locationNameFilter.value
      if (type === 'all' && tracking === 'all' && locationName === 'all') {
        this.filteredConnections = this.connections
        this.filteredCustomers = this.customers
        this.fixMap()
        return
      }
      if (type !== 'all') {
        this.filteredConnections = this.connections.filter(e => e.type === type)
        this.filteredCustomers = this.customers.filter(e => e.type === type)
      } else {
        this.filteredConnections = this.connections
        this.filteredCustomers = this.customers
      }
      if (tracking !== 'all') {
        this.filteredConnections = this.filteredConnections.filter(e => e.tracking === tracking)
        this.filteredCustomers = this.filteredCustomers.filter(e => e.tracking === tracking)
      } else {
        this.filteredConnections = this.filteredConnections
        this.filteredCustomers = this.filteredCustomers
      }
      if (locationName !== 'all') {
        this.filteredConnections = this.filteredConnections.filter(e => e.locationName === locationName)
        this.filteredCustomers = this.filteredCustomers.filter(e => e.locationName === locationName)
      } else {
        this.filteredConnections = this.filteredConnections
        this.filteredCustomers = this.filteredCustomers
      }
      this.fixMap()
    },
    resetColFilters () {
      this.typeFilter = { label: 'Todos', value: 'all' }
      this.trackingFilter = { label: 'Todos', value: 'all' }
      this.locationNameFilter = { label: 'Todos', value: 'all' }
      this.filteredConnections = this.connections
      this.filteredCustomers = this.customers
      this.$refs.filterCard.removeRefreshAnimation()
      this.getConnections()
    },
    markerIcon (alertState) {
      if (alertState) return 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
      else return 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
    },
    async getConnections () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get(
          '/api/v1/admin/company/connection/locations',
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.connections = data.connections
        this.customers = data.customers
        this.filteredConnections = this.connections
        this.filteredCustomers = this.customers
        this.ok = true
        this.fixMap()
      } catch (err) {
        console.log(err)
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  mounted () { this.getConnections() }
}
</script>

<style>
</style>
